(function($){
    'use strict';

	$('.tab-controls').each(function() {
		var $tabControls = $(this).find('.tab-controls__wrapper');

        $tabControls.attr('data-slides', $tabControls.find('.tab-controls__item').length);

	    $tabControls.on('init', function(event, slick){
			$tabControls.find('.slick-current .tab-controls__item').addClass('active');

            $tabControls.find('.slick-slide').click(function(e) {
                var $tab = $(this).find('.tab-controls__item');

                if(!$tab.hasClass('active')) {
                    changeActiveTab($tab);
                }

                return false;
            });

            if($('.page-controls').length) {
                $('.page-controls .next').click(function() {

                    var $nextSlide = $tabControls.find('.tab-controls__item.active').closest('.slick-slide').next(),
                        nextSlideIndex = $nextSlide.index();
                    
                    $tabControls.slick('slickGoTo', nextSlideIndex);
                    $nextSlide.click();
                    
                    var tabControlsOffset = $tabControls.offset();
                    $('html,body').animate({
                        scrollTop: tabControlsOffset.top,
                    }, 600);

                    return false;
                });

                $('.page-controls .prev').click(function() {
                    
                    var $prevSlide = $tabControls.find('.tab-controls__item.active').closest('.slick-slide').prev(),
                        prevSlideIndex = $prevSlide.index();

                    $tabControls.slick('slickGoTo', prevSlideIndex);
                    $prevSlide.click();

                    var tabControlsOffset = $tabControls.offset();
                    $('html,body').animate({
                        scrollTop: tabControlsOffset.top,
                    }, 600);
                    
                    return false;
                });

                checkPageControls($tabControls.find('.slick-current .tab-controls__item'));
            }
		});

		$tabControls.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			mobileFirst: true,
			fade: false,
			infinite: false,
            variableWidth: true,
            afterChange: function(slick, currentSlide){
                console.log(currentSlide);
            },
            responsive: [
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 1179,
                    settings: {
                        slidesToShow: 5
                    }
                }
            ]
		});
	});

    function changeActiveTab($tab) {
        $tab.closest('.tab-controls').find('.active').removeClass('active');
        $tab.addClass('active');

        var $content = $('.tab-content[data-tab="' + $tab.find('button').attr('data-tab') + '"]');
        if($content.length) {
            $('.tab-content.active').removeClass('active');
            $content.addClass('active');
        }

        checkPageControls($tab);
    }

    function checkPageControls($tab) {
        if(!$tab.closest('.slick-slide').prev().length) {
            $('.page-controls .prev').addClass('disabled');
        } else {
            $('.page-controls .prev').removeClass('disabled');
        }

        if(!$tab.closest('.slick-slide').next().length) {
            $('.page-controls .next').addClass('disabled');
        } else {
            $('.page-controls .next').removeClass('disabled');            
        }
    }
}(jQuery));